import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCart, removeItem, subscribe } from '../store/cart.js';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C', gray: '#888' };

// TODO(M2): Replace module-level cart store with React Context + persistent localStorage

function CartLineItem({ item, onRemove }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '80px 1fr auto',
      gap: '1.5rem',
      alignItems: 'center',
      padding: '1.5rem 0',
      borderBottom: `1px solid rgba(255,255,255,0.07)`,
    }}>
      {/* QR thumbnail */}
      <div style={{
        width: '80px',
        height: '80px',
        border: `1px solid rgba(255,255,255,0.15)`,
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridTemplateRows: 'repeat(5, 1fr)',
        gap: '1px',
        padding: '6px',
        backgroundColor: 'rgba(255,255,255,0.02)',
      }}>
        {Array.from({ length: 25 }).map((_, i) => (
          <div
            key={i}
            style={{
              backgroundColor: Math.sin(i * 7.3) > 0.1 ? COLORS.white : 'transparent',
            }}
          />
        ))}
      </div>

      {/* Item details */}
      <div>
        <p style={{
          margin: '0 0 0.3rem',
          fontSize: '0.8rem',
          fontWeight: 700,
          letterSpacing: '0.12em',
          color: COLORS.white,
        }}>
          {item.product.name}
        </p>
        {item.size && (
          <p style={{
            margin: '0 0 0.25rem',
            fontSize: '0.72rem',
            color: COLORS.gray,
            letterSpacing: '0.08em',
          }}>
            SIZE: {item.size}
          </p>
        )}
        <p style={{
          margin: 0,
          fontSize: '0.72rem',
          color: COLORS.gray,
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
          lineHeight: 1.5,
        }}>
          {item.product.tagline}
        </p>
      </div>

      {/* Price + remove */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '0.5rem',
      }}>
        <span style={{
          fontSize: '1rem',
          fontWeight: 700,
          color: COLORS.white,
        }}>
          ${item.product.price}
        </span>
        <button
          onClick={() => onRemove(item.id)}
          style={{
            background: 'none',
            border: 'none',
            color: COLORS.gray,
            fontSize: '0.7rem',
            letterSpacing: '0.1em',
            cursor: 'pointer',
            padding: 0,
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
          }}
        >
          REMOVE
        </button>
      </div>
    </div>
  );
}

export default function Cart() {
  const [cartItems, setCartItems] = useState(getCart());
  const navigate = useNavigate();

  useEffect(() => {
    // Subscribe to cart changes
    const unsubscribe = subscribe(() => setCartItems(getCart()));
    return unsubscribe;
  }, []);

  const subtotal = cartItems.reduce((sum, item) => sum + item.product.price, 0);

  function handleRemove(itemId) {
    removeItem(itemId);
    // State updates via subscription
  }

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
      <h1 style={{
        fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
        fontWeight: 900,
        letterSpacing: '-0.01em',
        color: COLORS.white,
        margin: '0 0 3rem',
      }}>
        YOUR CART
      </h1>

      {cartItems.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '6rem 2rem',
          borderTop: `1px solid rgba(255,255,255,0.08)`,
        }}>
          <p style={{
            color: COLORS.gray,
            fontSize: '0.9rem',
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            margin: '0 0 2rem',
          }}>
            Nothing here yet.
          </p>
          <Link to="/shop" style={{
            fontSize: '0.72rem',
            letterSpacing: '0.2em',
            fontWeight: 700,
            color: COLORS.gold,
            textDecoration: 'none',
          }}>
            BACK TO THE DROP
          </Link>
        </div>
      ) : (
        <>
          <div>
            {cartItems.map((item) => (
              <CartLineItem key={item.id} item={item} onRemove={handleRemove} />
            ))}
          </div>

          {/* Subtotal */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '2rem 0',
            borderTop: `1px solid rgba(255,255,255,0.08)`,
            marginTop: '1rem',
          }}>
            <span style={{
              fontSize: '0.75rem',
              letterSpacing: '0.15em',
              color: COLORS.gray,
              fontWeight: 600,
            }}>
              SUBTOTAL
            </span>
            <span style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: COLORS.white,
            }}>
              ${subtotal}
            </span>
          </div>

          <p style={{
            fontSize: '0.78rem',
            color: COLORS.gray,
            margin: '0 0 2rem',
            lineHeight: 1.6,
          }}>
            Shipping calculated at checkout. A QRQY account is required to complete your purchase —
            this is how your code gets activated.
          </p>

          <button
            onClick={() => navigate('/checkout')}
            style={{
              width: '100%',
              padding: '1.1rem',
              backgroundColor: COLORS.gold,
              color: COLORS.black,
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 800,
              letterSpacing: '0.2em',
              cursor: 'pointer',
            }}
          >
            PROCEED TO CHECKOUT
          </button>
        </>
      )}
    </div>
  );
}
